export default class EventBusService {
    public static CLOSE_POPUP = 'close_popup';
    public static OPEN_POPUP = 'open_popup';
    public static SIMPLE_FORM_SUCCESS_EVENT_NAME  = 'simple-form-success';
    public static CHANGE_SLIDE  = 'change';
    /**
     * Тригер события
     * @param {string} eventName
     * @param data
     */
    public static triggerEvent(eventName: string, data?: unknown): void {
        if (typeof CustomEvent === 'function') {
            const event = new CustomEvent(eventName, {
                detail: data,
            });
            document.dispatchEvent(event);
        } else {
            const event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, false, false, data);
            document.dispatchEvent(event);
        }
    }

    /**
     * Добавление слушателя событий
     * @param eventName
     * @param handler
     */
    public static addEventListener(
        eventName: string,
        handler: EventListenerOrEventListenerObject
    ): void {
        document.addEventListener(eventName, handler, false);
    }

    /**
     * Удаление слушателя событий
     * @param eventName
     * @param handler
     */
    public static removeEventListener(
        eventName: string,
        handler: EventListenerOrEventListenerObject
    ): void {
        document.removeEventListener(eventName, handler, false);
    }
}
